<template>
  <div>
    <el-button
      style="float: left; margin-left: 10px"
      type="primary"
      @click="()=>{showCreateAdmin = true;createErr=''}"
      :disabled="creating"
    >创建管理员</el-button>
    <el-table :data="adminList">
      <el-table-column
        prop="id"
        label="#ID"
      />
      <el-table-column
        prop="username"
        label="用户名"
      />
      <el-table-column
        prop="unionid"
        label="微信"
        :formatter="function(r, c, v, i) {
        return (v || '') != '' ? '已绑定' : '未绑定'
      }"
      />
      <el-table-column
        prop="time"
        label="创建时间"
      />
      <el-table-column
        prop="valid"
        label="状态"
        :formatter="function(r, c, v, i) { return v ? '活动' : '已禁用' }"
      />
      <el-table-column
        prop="id"
        label="绑定微信"
      >
        <template slot-scope="scope">
          <el-button size="mini" @click="handleBindWx(scope.row.id)">绑定微信</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="请输入管理员用户名"
      :visible.sync="showCreateAdmin"
      width="300px"
    >
      <div style="margin: 0 10px;">
        <el-input
          v-model='username'
          placeholder="请输入: 用户名"
        />
        <span style="color: red">{{ createErr }}</span>
      </div>
      <div style="text-align: center; margin-top: 10px">
        <el-button
          @click="createAdmin()"
          type="primary"
          :disabled="creating"
        >创建</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="请使用微信扫码"
      :visible.sync="showBindWechat"
      width="400px"
    >
      <div id="wx_bind"></div>
    </el-dialog>
  </div>
</template>
<script>
import request from '../../api/request'
import { WX_LOGIN_CB, WX_APPID } from '../../define'

export default {
  name: 'AdminList',
  data: function() {
    return {
      showBindWechat: false,
      creating: false,
      username: '',
      createErr: '',
      showCreateAdmin: false,
      adminList: []
    }
  },
  created: function() {
    this.loadList()
  },
  methods: {
    loadList() {
      request.admin.post('get_list', {}).then(resp => {
        this.adminList = resp.data.list
      })
    },
    createAdmin() {
      if (this.username === '') {
        this.createErr = '请输入用户名'
        return
      }
      this.$confirm("是否创建名为'" + this.username + "'的管理员？").then(() => {
        this.creating = true
        request.admin.post('create', { username: this.username }).then(() => {
          this.creating = false
          this.showCreateAdmin = false
          this.username=''
          this.loadList()
        }).catch(() => {
          this.creating = false
        })
      })
    },
    handleBindWx: function (aid) {
      this.showBindWechat = true
      setTimeout(() => {
        // eslint-disable-next-line
        new WxLogin({
          id: 'wx_bind',
          self_redirect: true,
          appid: WX_APPID,
          scope: 'snsapi_login',
          response_type: 'code',
          state: new Date().getTime(),
          redirect_uri: WX_LOGIN_CB
        })
        window.wxOauthCb = (code) =>  {
          request.admin.post('bind_wx', {
            id: aid,
            code: code,
            appid: WX_APPID
          }).then(resp => {
            if (resp.data) {
              this.showBindWechat = false
              this.$message.success('绑定成功')
            }
          })
        }
      }, 50)
    }
  }
}
</script>